import React from "react";
import { Typography, Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
// import NewsIMG from "../../../assets/images/news-img.png";
import dummyImg from "../../../assets/images/dummy.jpg";
import { CardHeading, DashboardCard } from "../Common";
import moment from "moment";
import { BASE_URL } from "../../../constant/apiURL";

const useStyles = makeStyles({
  cardContent: {
    padding: "15px 0px 0px 0px !important",
  },
  newsTitle: {
    textTransform: "uppercase",
    letterSpacing: "0px",
    wordSpacing: "0px",
  },
  image: {
    width: "100%",
    height: "56vh",
    maxHeight: "200px",
    objectFit: "contain",
  },
  createdAt: {
    fontWeight: 100,
    opacity: 0.8,
    marginBottom: "0 !important",
  },
});

function NewsCard(props) {
  const classes = useStyles();
  const newsData = props.newsData;

  const createdAt = moment(newsData?.createdAt).format("D MMMM");

  return (
    <DashboardCard
      moreButtonText="Read More"
      showMoreButton={true}
      innerCardContentNoPadding={true}
      innerCardNoShadow={true}
      viewMoreButtonNoPaddingTop={true}
      innerCardHorizontalPadding="16px"
      innerCardHorizontalPaddingRight="0px"
      onViewMoreClick={() => props.setOpen(!props.open)}
    >
      <Box sx={{ marginBottom: 0 }}>
        <CardHeading text="News" />
      </Box>
      <Grid container spacing={1} columnSpacing={-1}>
        <Grid item xs={12} md={6} className={classes.cardContent}>
          <Typography
            color="#000000"
            variant="button"
            component="h6"
            fontWeight={900}
            className={classes.newsTitle}
          >
            {newsData?.title}
          </Typography>
          <Typography color="#000000" variant="caption">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  newsData?.body.length > 100
                    ? newsData?.body.substr(0, 100) + "..."
                    : newsData?.body,
              }}
            ></div>
          </Typography>
          <Typography
            variant="overline"
            paragraph
            className={classes.createdAt}
          >
            {createdAt}
          </Typography>
        </Grid>
        <Grid item xs={0} md={1}></Grid>
        <Grid item xs={12} md={5} className={classes.cardContent}>
          <img
            src={
              newsData?.picture ? `${BASE_URL}${newsData?.picture}` : dummyImg
            }
            className={classes.image}
            alt="player-img"
          />
        </Grid>
      </Grid>
    </DashboardCard>
  );
}

export default NewsCard;
